module.exports = __webpack_public_path__ + "static/img/trash_add_card.0dd8389b.svg";